module.exports = __webpack_public_path__ + "static/media/janio_old_big_logo.5d615b9c.png";